//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconArrowResizeDiagonalLeft(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6.12378 6.1239L5.55811 12.6293L7.40364 14.4748L7.9764 7.97652L14.4747 7.40377L12.6292 5.55823L6.12378 6.1239ZM9.52496 16.5962L11.3705 18.4417L17.8759 17.876L18.4416 11.3706L16.596 9.52509L16.0233 16.0234L9.52496 16.5962Z" fill="currentColor" /></svg>;
}
export default IconArrowResizeDiagonalLeft;